<template>
  <div class="contract-change-manage-bd tb" v-if="funcView.contract_change_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <!-- 配置项 -->
        <el-form-item style="float: right; margin-right: 0">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('crm_contract_change.qsrhtbh')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <custom-select v-model="formSearch.changeType" code="contract_change_type" :placeholder="$t('crm_contract_change.bian_geng_lei_xing')" width="180px" value-type="number" @change="onPageChange({ page: 1 })"></custom-select>
        </el-form-item>
        <!-- 和表格列赛选重复了，删掉此处 -->
        <!-- <el-form-item style="float: right">
          <custom-select v-model="formSearch.changeState" code="crm_contract_change_state" placeholder="审批状态" width="130px" value-type="number" @change="onPageChange({ page: 1 })"></custom-select>
        </el-form-item> -->
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table height="100%" :index="true" :data="tableList" :column="tableColumn" @sort="sortChange" @filter="filterChange" :slots="['productDetail', 'action']">
        <!-- 操作 -->
        <el-table-column :label="i18n.com_action" min-width="200px" fixed="right" v-if="!!tableColumn.length && i18n.com_action">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="onChange(scope.row, 'watch')" v-if="funcView.contract_change_view">{{ funcView.contract_change_view }}</el-button>
            <el-button v-if="scope.row.changeState === 1 && funcView.contract_change_edit" type="text" size="mini" @click="onChange(scope.row, 'edit')">{{ funcView.contract_change_edit }}</el-button>
            <el-button v-if="scope.row.changeState === 1 && funcView.contract_change_delete" type="text" size="mini" @click="deleteChange(scope.row)">{{ funcView.contract_change_delete }}</el-button>
          </template>
        </el-table-column>
        <!-- 申请设备 -->
        <template v-slot:productDetail="scope">
          <el-popover placement="bottom" width="340" @show="getDeviceList(scope.row)" trigger="click">
            <el-table :data="scope.row.goodsList">
              <el-table-column width="110" property="productCode" :label="$t('crm_contract_change.xing_hao')"></el-table-column>
              <el-table-column width="200" property="bodyNum" :label="$t('crm_contract_change.ji_shen_hao')"></el-table-column>
            </el-table>
            <el-button slot="reference" type="text">{{ $t('crm_contract_change.cksbxq') }}</el-button>
          </el-popover>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <!-- 合同变更审批弹窗 -->
    <approval-dialog v-if="dialogVisible" :model="dialogModel" @success="getTableList()" @close="dialogVisible = false"></approval-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import approvalDialog from '@/components/approvalCenter/approval_dialog.vue';

export default {
  components: {
    approvalDialog,
  },
  name: 'contract_contractChange',
  data() {
    return {
      tableCode: 'contract_change',
      // changeTypeDic: {},
      formSearch: {
        changeState: '',
        changeType: '',
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,
      },
      tableList: [],
      totalRows: 0,

      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogModel: {},
    };
  },
  mounted: function () {
    this.getTableColumn();
    this.getTableList();
    this.getFuncView();
    // this.getDictionary('crm_contract_change_type', (data) => {
    //   this.changeTypeDic = this.$listTransObject(data.crm_contract_change_type, 'value', 'code');
    // });
  },
  methods: {
    // 获取表格数据列表
    getTableList: function () {
      this.$getJSON(apis.OrderChangePage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 获取变更设备
    getDeviceList(row) {
      this.$getJSON(apis.OrderChangeManageList, {
        changeOrderId: row.changeOrderId,
      }).then((res) => {
        const list = res.data;
        this.$set(row, 'goodsList', list);
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 删除变更
    deleteChange: function (row) {
      this.$showConfirm(this.$t('crm_contract_change.qdyscgbgsqm')).then(() => {
        this.$postJSON(`${apis.OrderChangeDelete}/${row.changeOrderId}`).then(() => {
          this.$message({
            message: this.$t('Common.com_delete_success'),
            type: 'success',
          });
          this.getTableList();
        });
      });
    },
    // 编辑/查看变更
    onChange: function (row, type) {
      let changeType = '';
      if (`${row.changeType}` === '3' && Number.parseInt(row.contractType, 10) > 40 && Number.parseInt(row.contractType, 10) < 50) {
        changeType = 'change_order_sale_device';
      } else if (`${row.changeType}` === '20' && Number.parseInt(row.contractType, 10) > 40 && Number.parseInt(row.contractType, 10) < 50) {
        changeType = 'change_order_stop_sale';
      }
      const dicMap = {
        3: 'change_order_device',
        22: 'change_order_stop_contract',
        11: 'change_order_rent_time',
        12: 'change_order_after_service',
        13: 'change_order_pause_use',
        14: 'change_order_end_pause_use',
        20: 'change_order_stop_rent',
        24: 'change_order_stop_test',
        16: 'change_order_payment_period',
      };
      this.dialogModel.type = type;
      this.dialogModel.changeType = changeType || dicMap[`${row.changeType}`]; // 特殊处理，2套字典引起的问题（crm_contract_change_type， approval_type）
      this.dialogModel.orderId = row.orderId;
      this.dialogModel.changeId = row.changeOrderId;
      this.dialogModel.row = row;
      this.dialogVisible = true;
    },
  },
};
</script>
